import { render, staticRenderFns } from "./Prizes.vue?vue&type=template&id=0eb573fc&"
import script from "./Prizes.js?vue&type=script&lang=js&"
export * from "./Prizes.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports